import Modal from 'design-system/ModalWeb';
export default Modal;
